<section class="container">
  <div class="flex flex-row justify-between items-start mb-1">
    <rfc-heading-widget [headingName]="defineTitleAndDescriptionWidgetObj('connect_user')"></rfc-heading-widget>
    <mat-icon class="pointer" (click)="close()">close</mat-icon>
  </div>

  <mat-card class="mat-custom-card-shadow mat-custom-card">
    <rfc-read-more [text]="'connect_user_desc' | i18n" [maxLength]="isMobile ? 100 : undefined"></rfc-read-more>
  </mat-card>

  <div class="flex flex-col-reverse md:flex-col-reverse lg:flex-row justify-center gap-[2em] mt-1 mb-1">
    <button mat-raised-button (click)="onSubmit()" class="ald-mat-button primary w-full md:w-auto">
      {{ "confirm" | i18n }}
    </button>
  </div>
</section>